import config from "@/config";
import actions from "@/store/actions";
import { bulletinModule } from "@/store/bulletinModule";
import { deliveryDateModule } from "@/store/deliveryDateModule";
import { eventsModule } from "@/store/eventsModule";
import { globalSearchModule } from "@/store/globalSearchModule";
import { iframesModule } from "@/store/iframesModule";
import { materialModule } from "@/store/materialModule";
import mutations from "@/store/mutations";
import { newsModule } from "@/store/newsModule";
import { orderingPermissionModule } from "@/store/orderingPermissionModule";
import { ordersModule } from "@/store/ordersModule";
import { partnerInfoModule } from "@/store/partnerInfoModule";
import { productAvailability } from "@/store/productAvailabilityModule";
import { productDataModule } from "@/store/productDataModule";
import { productSearchModule } from "@/store/productSearchModule";
import { projectModule } from "@/store/projectModule";
import { returnsModule } from "@/store/returnsModule";
import { shoppingCartModule } from "@/store/shoppingCartModule";
import { solutionsModule } from "@/store/solutionsModule";
import { IRootState, User } from "@iloq/shared";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// @ts-expect-error __FEATURE_FLAGS__ is injected by VITE
const localFeatureFlags = __FEATURE_FLAGS__;
if (localFeatureFlags && Object.keys(localFeatureFlags).length) {
  console.log("Local featureFlag overrides:", localFeatureFlags);
}

const state: IRootState = {
  user: undefined as unknown as User,
  gdprDialog: {
    active: false,
  },
  generalError: {
    active: false,
    isBlockedError: undefined,
    dialogTitle: undefined,
    dialogText: undefined,
    error: undefined,
  },
  generalInfo: {
    active: false,
    dialogTitle: undefined,
    dialogText: undefined,
  },
  /* If features are defined in config, use that. Otherwise use defaults, with possible overrides from .env.local */
  features:
    config.get("features") ??
    Object.assign(
      {
        partnerProgram: true,
        userManagement: true,
        rescheduleSurveys: true,
        supportRequests: true,
        solutions: true,
        gdprDialog: true,
        warrantyinfo: true,
        partnerInfoManagement: true,
        campaignReturns: true,
        productReturnDrafts: false,
        useDHLInAddressValidation: true,
        loginReact: false,
        bulletinReact: false,
      },
      localFeatureFlags ?? {},
    ),
} as IRootState;

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    productSearch: productSearchModule,
    returns: returnsModule,
    iframes: iframesModule,
    news: newsModule,
    bulletin: bulletinModule,
    partnerInfo: partnerInfoModule,
    productData: productDataModule,
    shoppingCart: shoppingCartModule,
    orders: ordersModule,
    events: eventsModule,
    material: materialModule,
    solutions: solutionsModule,
    productAvailability: productAvailability,
    orderingPermission: orderingPermissionModule,
    deliveryDate: deliveryDateModule,
    globalSearch: globalSearchModule,
    project: projectModule,
  },
  getters: {
    user: (state) => state.user,
  },
});

export default store;
